(function () {
    'use strict';

    a3_pilot_reports.factory('RequestFactory', RequestFactory);

    /**
    * @memberof PilotReports
    * @ngdoc factory
    * @name RequestFactory
    * @description 
    *   Add & delete requests and get Roster Requests & get ancillaries
    * @ngInject
    */
    function RequestFactory($http, apiUrl, GenericService) {
        /**
        * Initialize the CrewAssessment
        * @memberof AssessmentSyncResultFactory
        */
        function RequestSubmissionDeadline() {
            this.showSubmissionDeadlineModal = false;
        }

        var submitResponseObj = { success: false, message: '', data: null };
        var objType = 'requestSubmissionEndDates'
        var objCallback = RequestSubmissionDeadline;

        var service =
        {
            setSubmissionDeadlineDateToStorage: setSubmissionDeadlineDateToStorage,
            getSubmissionDeadlineDateFromStorage: getSubmissionDeadlineDateFromStorage,
            showSubmissionDeadlineModal: showSubmissionDeadlineModal,
            showSubmissionDeadlineAlert: showSubmissionDeadlineAlert,
            updateShowSubmissionDeadlineModal: updateShowSubmissionDeadlineModal,
            getActiveRequests: getActiveRequests,
            getAncillaries: getAncillaries,
            sendFlightRequest: sendFlightRequest,
            sendShiftRequest: sendShiftRequest,
            sendOvernightRequest: sendOvernightRequest,
            sendOtherRequest: sendOtherRequest,
            sendGroundRequest: sendGroundRequest,
            deleteFlightRequest: deleteFlightRequest,
            deleteShiftRequest: deleteShiftRequest,
            deleteOvernightRequest: deleteOvernightRequest,
            deleteOtherRequest: deleteOtherRequest,
            deleteGroundRequest: deleteGroundRequest,
            getPastRequests: getPastRequests
        };

        /**
         * Save submission end date of crew member's qualification group to storage
         * @param {array} objList A list of Crew Expiries
         */
        function setSubmissionDeadlineDateToStorage(objList) {
            if (objList != null) {
                var submissionDeadline = { submissionEndDate: objList, showSubmissionDeadlineModal: true };
                GenericService.saveOne(submissionDeadline, objType, objCallback);
            }
        }

        /**
         * Calculates days left
         * @memberof CalendarCtrl
         * @return {string} usage
         */
        function daysDiff(date) {
            var today = moment().startOf('day');
            var expiryDate = moment(date);

            return expiryDate.diff(today, 'days');
        }

        /**
         * Get submission end date of crew member's qualification group from storage
         */
        function getSubmissionDeadlineDateFromStorage() {
            return GenericService.getOne(objType, objCallback);
        }

        /**
         * Shows submission deadline modal
         * @memberof ExpiriesFactory
         * @returns {bool} returns the value of showSubmissionDeadlineModal property
         */
        function showSubmissionDeadlineModal() {
            var needsReminder = false;
            var submissionDeadline = getSubmissionDeadlineDateFromStorage();
            if(submissionDeadline){
                var diffDays = daysDiff(submissionDeadline.submissionEndDate);

                if (submissionDeadline && submissionDeadline.submissionEndDate && submissionDeadline.showSubmissionDeadlineModal) {
                    if (diffDays == 1 || diffDays == -1 || diffDays == 0) {
                        needsReminder = true;
                    }
                }
            }

            return needsReminder;
        }

        /**
         * Shows submission deadline alert
         * @memberof ExpiriesFactory
         * @returns {bool} returns the value of showSubmissionDeadlineAlert property
         */
        function showSubmissionDeadlineAlert() {
            var needsAlert = false;
            var submissionDeadline = getSubmissionDeadlineDateFromStorage();
            if(submissionDeadline){
                var diffDays = daysDiff(submissionDeadline.submissionEndDate);
    
                if (submissionDeadline && submissionDeadline.submissionEndDate) {
                    if (diffDays <= 10 && diffDays >=0) {
                        needsAlert = true;
                    }
                }
            }

            return needsAlert;
        }

        /* Update submissionEndDate modal object to storage
        * @memberof RequestFactory
        * @param {bool} canShowModal whether the modal can be displayed
        */
        function updateShowSubmissionDeadlineModal(canShowModal) {
            var submissionDeadline = getSubmissionDeadlineDateFromStorage();
            submissionDeadline.showSubmissionDeadlineModal = canShowModal;
            GenericService.saveOne(submissionDeadline, objType, objCallback);
        }

        /**
        * Gets all types of the existing requests
        */
        function getActiveRequests() {
            return $http.get(apiUrl + '/RosterRequests/GetRequests', { 'Content-Type': 'application/json' })
                .then(res => getResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Gets all ancilleries
        */
        function getAncillaries() {
            return $http.get(apiUrl + '/RosterRequests/GetAncillaries', { 'Content-Type': 'application/json' })
                .then(res => getResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Sends the flight request
        */
        function sendFlightRequest(rosterRequest) {
            var requestTimesFixed = { ...rosterRequest };
            if(rosterRequest.afterTime){
                requestTimesFixed.afterTime = rosterRequest.afterTime.clone();
                var startDateObj = new Date(requestTimesFixed.afterTime).fromUTC();
                requestTimesFixed.afterTime = moment(startDateObj);
            }else{
                requestTimesFixed.afterTime = null;
            }
            if(rosterRequest.beforeTime){
                requestTimesFixed.beforeTime = rosterRequest.beforeTime.clone();
                var endDateObj = new Date(requestTimesFixed.beforeTime).fromUTC();
                requestTimesFixed.beforeTime = moment(endDateObj);
            }else{
                requestTimesFixed.beforeTime = null;
            }
            var rosterRequestsURL = apiUrl + '/RosterRequests/FlightRequestInsert';
            return $http.post(rosterRequestsURL, requestTimesFixed, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Sends the shift request
        */
        function sendShiftRequest(rosterRequest) {
            var rosterRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestInsert';
            return $http.post(rosterRequestsURL, rosterRequest, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Sends the overnight request
        */
        function sendOvernightRequest(rosterRequest) {
            var rosterRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestInsert';
            return $http.post(rosterRequestsURL, rosterRequest, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Sends the other request
        */
        function sendOtherRequest(rosterRequest) {
            var rosterRequestsURL = apiUrl + '/RosterRequests/OtherRequestInsert';
            return $http.post(rosterRequestsURL, rosterRequest, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Sends the ground request
        */
        function sendGroundRequest(rosterRequest) {
            var rosterRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestInsert';
            return $http.post(rosterRequestsURL, rosterRequest, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res))
                .catch(res => getResponseFailed(res));
        }

        /**
        * Gets the response message
        */
        function getResponse(res) {
            submitResponseObj.success = res.data.success;
            if (res.data.success) {
                submitResponseObj.message = "Data retrieved successfully";
                submitResponseObj.data = res.data.data;
            }
            else {
                submitResponseObj.message = res.data.errorMessage;
            }
            return submitResponseObj;
        }

        /**
        * Gets the creation response message
        */
        function getCreateRequestResponse(res) {
            submitResponseObj.success = res.data.success;
            if (res.data.success) {
                submitResponseObj.message = "Request submited successfully";
                submitResponseObj.data = res.data.data;
            }
            else {
                submitResponseObj.message = res.data.errorMessage;
            }
            return submitResponseObj;
        }

        /**
        * Gets the response failure message
        */
        function getResponseFailed(res) {
            submitResponseObj.success = false;
            submitResponseObj.message = "Something went wrong!"
            return submitResponseObj;
        }

        /**
        * Deletes the flight request
        */
        function deleteFlightRequest(requestId) {
            var deleteRequestsURL = apiUrl + '/RosterRequests/FlightRequestDelete';
            return $http.post(deleteRequestsURL, requestId, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res));
        }

        /**
        * Deletes the shift request
        */
        function deleteShiftRequest(requestId) {
            var deleteRequestsURL = apiUrl + '/RosterRequests/ShiftTimeRequestDelete';
            return $http.post(deleteRequestsURL, requestId, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res));
        }

        /**
        * Deletes the overnight request
        */
        function deleteOvernightRequest(requestId) {
            var deleteRequestsURL = apiUrl + '/RosterRequests/OvernightsRequestDelete';
            return $http.post(deleteRequestsURL, requestId, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res));
        }

        /**
        * Deletes the other request
        */
        function deleteOtherRequest(requestId) {
            var deleteRequestsURL = apiUrl + '/RosterRequests/OtherRequestDelete';
            return $http.post(deleteRequestsURL, requestId, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res));
        }

        /**
        * Deletes the ground request
        */
        function deleteGroundRequest(requestId) {
            var deleteRequestsURL = apiUrl + '/RosterRequests/GroundDutyRequestDelete';
            return $http.post(deleteRequestsURL, requestId, { 'Content-Type': 'application/json' })
                .then(res => getCreateRequestResponse(res));
        }

          /**
        * Gets all types of the past requests
        */
          function getPastRequests() { 
            return $http.get(apiUrl + '/RosterRequests/GetPastRequests', { 'Content-Type': 'application/json' })
                .then(res => getResponse(res))
                .catch(res => getResponseFailed(res));
        }

        return service;
    }

})();